import React, { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import { StyledTextField } from "@components/CustomInput/customInput";
import SearchIcon from "@mui/icons-material/Search";

const SearchInput: React.FC<{
  data: Record<string, any[]>;
  selected: string;
  searchedResult: (result: Record<string, string[]>) => void;
}> = ({ data, selected, searchedResult }) => {
  const [query, setQuery] = useState("");

  const searchInData = (data: any, query: string) => {
    if (data && query && selected) {
      const searchResult = data?.[selected]?.filter((result: any) =>
        result?.toLowerCase().includes(query?.toLowerCase()),
      );
      const searchedData = { [selected]: searchResult };
      return searchedData;
    }
    return data;
  };

  useEffect(() => {
    const searchedData = searchInData(data, query);
    searchedResult(searchedData);
  }, [query, selected]);

  return (
    <div className="relative w-full">
      {/* Search Icon */}
      {/* <span
        style={{
          position: "absolute",
          left: "12px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer",
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14px"
          height="14px"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
      </span> */}

      <SearchIcon
        sx={{
          position: "absolute",
          left: "12px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer",
          width: 20,
          height: 20,
          color: "#9E9E9E",
        }}
      />

      {/* Input Field */}
      <StyledTextField
        type="text"
        placeholder="Search Stage"
        className="body-xs font-regular"
        onChange={(e) => {
          setQuery(DOMPurify.sanitize(e.target.value));
        }}
        value={query}
        variant="outlined"
        fullWidth
        sx={{
          "& .MuiOutlinedInput-root": {
            border: "1px solid #CFDAE7",
            background: "transparent",
            color: "#1E293B",
            borderRadius: "6px",
            paddingLeft: "35px",
            "& input": {
              padding: "10px 12px",
              paddingLeft: 0,
            },
            "& fieldset": {
              border: "none",
            },
            "&:hover fieldset": {
              border: "none",
            },
            "&.Mui-focused fieldset": {
              border: "none",
            },
          },
        }}
      />
    </div>
  );
};

export default SearchInput;
